import { PaperclipIcon } from '@phosphor-icons/react';

type EventFileCountBadgeProps = {
  count: number;
};

export function EventFileCountBadge({ count }: EventFileCountBadgeProps) {
  if (count <= 0) {
    return null;
  }

  return (
    <span
      className="inline-flex items-center gap-1 rounded bg-slate-700 px-2 py-0.5 text-xs text-slate-100"
      aria-label={`${count} event ${count === 1 ? 'PDF' : 'PDFs'}`}
      data-testid="event-file-count"
    >
      <PaperclipIcon size={14} weight="fill" className="text-red-300" />
      {count}
    </span>
  );
}
